import { Dispatch, SetStateAction } from 'react';
import { ApiData } from './apiService';

interface NewRowData {
    order_table: keyof ApiData;
    order_data: any[];
}

export const socketNewRow = (
    { order_table, order_data }: NewRowData,
    setApiData: Dispatch<SetStateAction<ApiData | null>>
) => {
    if (!order_data || !order_table) return;
    console.log(order_data);
    setApiData(prevData => {
        if (!prevData) return prevData;
        
        const currentTable = prevData[order_table];
        // Check if the table exists and is an array
        if (!Array.isArray(currentTable)) {
            // Either ignore the update...
            return prevData;
            // ...or initialize it:
            // return { ...prevData, [order_table]: [...order_data] };
        }
    
        return {
            ...prevData,
            [order_table]: [
                ...(currentTable as any[]),
                ...order_data,
            ],
        };
    });
};